import { BIButton } from '@pulsepointinc/bi-components';
import styled from 'styled-components';

export const StyledBulkButton = styled(BIButton)`
  position: absolute;
  top: 0;
  right: 24px;
  z-index: 10;
  gap: 4px;
`;
